module.exports = __webpack_public_path__ + "static/media/gilderise.8c46985f.jpeg";